export function getRowValue (row, keyOrKeys) {
  if (typeof keyOrKeys === 'string') {
    return row[keyOrKeys]
  }

  if (Array.isArray(keyOrKeys)) {
    for (const key of keyOrKeys) {
      if (row[key] !== undefined && row[key] !== null) {
        return row[key]
      }
    }
  }

  return undefined
}
